module.exports = __webpack_public_path__ + "static/media/iconUpload.65cb39ef.svg";